/**
 * Segmented-trends & user-trend の共通項目
 */

// Detail があるページ
export enum AnalysisToolsDetailType {
  Inflow = "Inflow",
  Event = "Event"
}
